import axios from 'axios'
import themeConfig from '@configs/themeConfig'
import { customFormatDate } from "../../../../../utility/Utils";
import { useSkin } from '../../../../../utility/hooks/useSkin';
import { handleSkin } from '../../../../../redux/layout';
const path = themeConfig.app.apiUrl;


export const getRecords = (params = {}, abortController) => {
    return (dispatch, state) => {
        const { filters } = state().datatable;
        const abort = abortController ? { signal: abortController.signal } : {};
        const updateFilters = { ...filters, ...params }
        dispatch({ type: 'SET_FILTERS', 'payload': updateFilters });
        let queryRange = [];
        if (updateFilters['dateRange'].length > 0) {
            queryRange = customFormatDate(updateFilters['dateRange'][0]) + "," + customFormatDate(updateFilters['dateRange'][1], "end");
        }
        dispatch({ type: 'SET_LOADING', 'payload': true });
        return axios.get(`${path}/${updateFilters['url']}`, { params: { ...updateFilters, dateRange: queryRange }, signal: abort.signal }).then(({ data }) => {
            dispatch({ type: 'SET_RECORDS', payload: data?.records });
            Array.isArray(data?.tools) && dispatch({ type: 'SET_TOOL', payload: data?.tools });
            Array.isArray(data?.roles) && dispatch({ type: 'SET_ROLE', payload: data?.roles });
            Array.isArray(data?.dealers) && dispatch({ type: 'SET_DEALER', payload: data?.dealers });
            dispatch(subDealerPerm(data?.records))
            return data
        }).finally(() => dispatch({ type: 'SET_LOADING', 'payload': false }))
    }
}
const subDealerPerm = (records) => {
    return (dispatch, state) => {
        let data = records

        data['data'] = records?.data?.map(item => {
            let disabled = false;
            if (item?.sub_customer?.length === 0) {
                disabled = true;
            }
            return { ...item, disabled };
        });
        dispatch({ type: 'SET_DEALER_RECORDS', payload: { data } })
    }
}

export const getDropDown = (url) => {
    return (dispatch, state) => {
        return axios.get(`${path}/${url}`)
            .then(({ data }) => {
                dispatch({ type: 'SET_DROPDOWN_DATA', payload: data.records });
                return data
            })
    }
}


export const resetUserPassword = (payload) => {
    return (disaptch) => {
        return axios.post(`${path}/user/forgot-password/reset`, payload);
    };
};


export const verifyPasswordReset = (payload) => {
    return (dispatch) => {
        return axios.post(`${path}/user/forgot-password/verify`, payload);
    };
};


export const setFilterValues = payload => dispatch => dispatch({ type: 'SET_FILTER_VAL', payload })

/* export const setFilterEmpty= async(filter)=>{
    return async (dispatch,state)  => {
        return await dispatch(filter);
    }
} */